
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ftl",
      function () {
        return require("private-next-pages/ftl.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ftl"])
      });
    }
  